// Date helper functions
export function addDays(days: number): Date {
  const next = new Date();
  next.setDate(next.getDate() + days);
  return next;
}

export function upcomingWeekend(): Date {
  const today = new Date();
  const day = today.getDay();
  const offset = day <= 6 ? (6 - day) : 0;
  return addDays(offset || 7);
}

export function nextWeekday(targetWeekday: number): Date {
  const date = new Date();
  const currentDay = date.getDay();
  let offset = (targetWeekday + 7 - currentDay) % 7;
  if (offset === 0) {
    offset = 7;
  }
  return addDays(offset);
}

export function upcomingWeekday(targetWeekday: number): Date {
  const today = new Date();
  const currentDay = today.getDay();
  let offset = (targetWeekday + 7 - currentDay) % 7;
  if (offset === 0) {
    offset = 7;
  }
  return addDays(offset);
}

export function endOfMonth(): Date {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

// Quick options for schedule date picker
export const scheduleQuickOptions = [
  { label: 'Today', getDate: () => new Date() },
  { label: 'Tomorrow', getDate: () => addDays(1) },
  { label: 'Next Monday', getDate: () => nextWeekday(1) },
];

// Quick options for due date picker
export const dueQuickOptions = [
  { label: 'Today', getDate: () => new Date() },
  { label: 'Tomorrow', getDate: () => addDays(1) },
  { label: 'Next Monday', getDate: () => nextWeekday(1) },
];
